
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"form-group",class:[css_classes, {invalid: errors, required: required}]},[_c('label',{attrs:{"for":id}},[_v(_s(label_text))]),_c('input',{ref:"textInput",attrs:{"id":id,"readonly":readonly,"type":input_attrs.type},domProps:{"value":value},on:{"input":function($event){return updateText()}}}),(errors)?[_c('div',{staticClass:"errors"},[_v(_s(label_text)+" "+_s(errors.join(", "))+".")])]:_e()],2)}},
      staticRenderFns: []
    };
  